module.exports = __webpack_public_path__ + "img/caterina-bueno.823cb772.jpg";